<template>
  <el-dialog
    title="修改出证日期"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item label="证书编号：">{{ info.certNo }}</el-form-item>
      <el-form-item
        label="出证日期："
        prop="certIssuanceTime">
        <el-date-picker
          v-model="info.certIssuanceTime"
          :clearable="false"
          :editable="false"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Cert from '@/service/cert'
export default {
  name: 'EditCertTimeModal',
  data() {
    return {
      loading: false,
      visible: false,
      info: { identificationCertId: null, certNo: '', certIssuanceTime: null },
      rules: {
        certIssuanceTime: [
          { required: true, message: '请选择出证日期', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = { identificationCertId: null, certNo: '', certIssuanceTime: null }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          Cert.updateidentificationcert({ ...this.info })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success(message)
                this.$emit('fetch')
                this.toggleModal(false)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    update(options = {}) {
      this.info = { ...this.info, ...options }
      this.toggleModal(true)
    }
  }
}
</script>
